// eslint-disable-next-line unicorn/prevent-abbreviations
import controller from './kform-dev-toolbar.controller';
import template from './kform-dev-toolbar.html';
import './kform-dev-toolbar.scss';

export default {
	controller,
	template,
	bindings: {
		disabled:  '<?ngDisabled',
		form:      '<',
	},
	controllerAs: '$ctrl',
	require: {
		parent: '^^kformTabForm',
	},
};
